<ac-card class="no-purchase-necessary">
  <ac-card-header
    title="No Purchase Necessary"
    subtitle="Gains.com is a social casino that is completely free to play. There is no purchase necessary. You can get SC (Sweeps Coins) and GC (Gold Coins) for free at any time."
    [hideBack]="true"
    (close)="dialogRef.close()">
  </ac-card-header>

  <ac-card-content>
    <div class="ac-flex-col ac-gap-md">
      <mat-expansion-panel hideToggle #panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            What are&nbsp;<app-sc-icon [size]="16" />&nbsp;Sweeps Coins (SC)?
            <span class="chevron" [class.open]="panel.expanded">
              <ac-icon iconKey="hr:chevron_right" [size]="8" />
            </span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="ac-body-md exp-body">
          Sweeps Coins are redeemable for cash and crypto prizes subject to
          eligibility and sweepstakes rules.
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel hideToggle #panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            How do I get&nbsp;<app-sc-icon [size]="16" />&nbsp;Sweeps Coins (SC)?
            <span class="chevron" [class.open]="panel.expanded">
              <ac-icon iconKey="hr:chevron_right" [size]="8" />
            </span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="ac-body-md exp-body">
          <ul>
            <li>As a free bonus for purchasing Gold Coins</li>
            <li>Mailing in a postcard</li>
            <li>Claiming your daily bonus</li>
            <li>
              Participating in giveaways on any of our Social Media handles
            </li>
          </ul>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel hideToggle #panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            What are&nbsp;<app-gc-icon [size]="16" />&nbsp;Gold Coins (GC)?
            <span class="chevron" [class.open]="panel.expanded">
              <ac-icon iconKey="hr:chevron_right" [size]="8" />
            </span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="ac-body-md exp-body">
          Gold Coins have no value and allow you to play on the social casino
          for free!
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel hideToggle #panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            How do I get&nbsp;<app-gc-icon [size]="16" />&nbsp;Gold Coins (GC)?
            <span class="chevron" [class.open]="panel.expanded">
              <ac-icon iconKey="hr:chevron_right" [size]="8" />
            </span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="ac-body-md exp-body">
          <ul>
            <li>Claiming your daily bonus</li>
            <li>Free top up</li>
            <li>Purchasing them</li>
          </ul>
        </div>
      </mat-expansion-panel>
    </div>
  </ac-card-content>
  <ac-card-actions>
    <div class="ac-label ac-body-sm">
      There is no purchase required to use this platform. You can play with Gold
      Coins (GC) at any time and refill your Gold Coins (GC) when you run out by
      going to your wallet.
    </div>
  </ac-card-actions>
</ac-card>
